import React, { memo, useState } from "react";
import { FaCaretUp, FaCaretDown } from "react-icons/fa";
import styles from "../table.module.scss";
import { useSelector } from "react-redux";

const TableHead = ({
  tableHead,
  handleCheckAllBox,
  isCheckAll,
  tableBody,
  handleShowGlobalViewModal,
  handleEdit,
  handleDelete,
  handlePermission,
  redirectReferrerPaymentPage,
  handleSorting,
  payemntHeaderColor: currentModuleType,
  handleCancel,
}) => {
  const { tableBgColor } = useSelector((state) => state.tableStatusChange);
  const { tableBgColorpayment } = useSelector((state) => state.tablePaidStatus);
  const finalBgColor =
    currentModuleType === "paymentTabcolor" ? tableBgColorpayment : tableBgColor;
  return (
    <thead className="thead-info">
      <tr>
        {handleCheckAllBox && (
          <th className="width50" style={{ backgroundColor: finalBgColor }}>
            <div className="form-check custom-checkbox checkbox-success check-lg me-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="check_all"
                checked={isCheckAll}
                onChange={() => handleCheckAllBox(tableBody)}
                style={{ backgroundColor: "#fff" }}
              />
              <label className="form-check-label" htmlFor="check_all"></label>
            </div>
          </th>
        )}
        {tableHead &&
          tableHead?.map((item, i) => (
            <th
              key={i}
              className={item?.searchable && styles["tableHead"]}
              style={{ backgroundColor: finalBgColor }}
            >
              {item?.title}{" "}
              {item?.searchable && (
                <div className={styles["sort-icon"]}>
                  <FaCaretUp
                    onClick={() => handleSorting(item?.title, "asc")}
                  />
                  <FaCaretDown
                    onClick={() => handleSorting(item?.title, "desc")}
                  />
                </div>
              )}
            </th>
          ))}
        {(handleShowGlobalViewModal ||
          handleEdit ||
          handleDelete ||
          handlePermission||handleCancel) && (
          <th style={{ backgroundColor: finalBgColor }}>Action</th>
        )}
        {redirectReferrerPaymentPage && (
          <th style={{ backgroundColor: finalBgColor }}>Payments</th>
        )}
      </tr>
    </thead>
  );
};

export default memo(TableHead);